import { Center } from "@chakra-ui/react";
import onboardingParty from "assets/images/svgs/onboarding-party.svg";
import history from "infra/helpers/history";
import CardOnboarding from "../components/card-onboarding";
import useFinishOnboarding from "core/features/onboarding/hooks/useFinishOnboarding";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function QuintoPasso() {
  const { tenant } = useCurrentTenant();
  const { mutate: handleSave } = useFinishOnboarding(tenant.id);

  const finalizarOnboard = () => {
    handleSave(undefined, {
      onSuccess: (data: any) => {
        console.log("Salvo", data);
      },
      onError: (err: any) => {
        console.log("Erro", err);
      },
    });
    history.push("/dashboard");
  };

  return (
    <Center w="100vw" h="100vh">
      <CardOnboarding
        imageSrc={onboardingParty}
        headingText="Comece a usar agora!"
        subheadText=""
        onNext={finalizarOnboard}
        onNextText="COMEÇAR"
        step={5}
      />
    </Center>
  );
}

export default QuintoPasso;
